import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { ProgramCapabilitiesTab } from '../tabs/ProgramCapabilitiesTab';
export function CapabilitiesPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(ProgramCapabilitiesTab, {
            programId: programId
        })
    });
}
